<h2 mat-dialog-title>Reason for Decline</h2>
<mat-dialog-content>
  <mat-form-field class="w-full">
    <mat-label>Reason</mat-label>
    <textarea matInput [(ngModel)]="reason" rows="4"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button color="primary" (click)="submit()">Submit</button>
</mat-dialog-actions>
